import type { ThemeOptions } from "@mui/material/styles";

type TypographyOptions = ThemeOptions["typography"];

// PEAK4 2026 typography.
// Core typeface: Open Sans. Headlines (H1): Montserrat Bold.
const openSans = '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif';
const montserrat = '"Montserrat", ' + openSans;

export const typography: TypographyOptions = {
  fontFamily: openSans,
  // Headlines use Montserrat Bold for strong, confident titles.
  h1: {
    fontFamily: montserrat,
    fontWeight: 700,
  },
  h2: {
    fontFamily: montserrat,
    fontWeight: 700,
  },
  h3: {
    fontFamily: montserrat,
    fontWeight: 700,
  },
};
